import { ComponentType } from '@/src/interfaces/data-contracts';

export const getComponentType = (component: string): ComponentType => {
  switch (true) {
    case component.toLowerCase() === 'list':
      return ComponentType.List;
    case component.toLowerCase() === 'modules':
      return ComponentType.Modules;
    case component.toLowerCase() === 'detail':
      return ComponentType.Detail;
    case component.toLowerCase() === 'score':
      return ComponentType.Score;
    default:
      return ComponentType.All;
  }
};
